import { Divider, TextField, Select, MenuItem, Box, Grid, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import AuthTypeText from "./AuthTypeText";
import TextFieldWithVariableTooltip from "components/Common/TextFieldWithVariableTooltip";

const ApiKeyAuthorization = ({
  authorization, onAuthorizationUpdate,
}) => {
  const [value, setValue] = useState(authorization?.value);
  const [key, setKey] = useState(authorization?.key);
  const [authType, setAuthType] = useState(authorization?.authType);

  const handleInputChange = (field, value) => {
    if (field === 'Value') setValue(value);
    else if (field === 'Key') setKey(value);
    else setAuthType(value);
  }

  const handleApiCall = async () => {
    await onAuthorizationUpdate({
      authorization_value: {
        key: key,
        value: value,
        add_to: authType
      }
    });
  }

  return (
    <Box p={2}>
      <AuthTypeText />
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3}>
          <Typography variant="body" sx={{ color: 'var(--text-primary)' }}>Key:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            size="small"
            variant="outlined"
            value={key}
            onChange={(e) => handleInputChange('Key', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body" sx={{ color: 'var(--text-primary)' }}>Value:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextFieldWithVariableTooltip
            size="small"
            variant="outlined"
            value={value}
            onChange={(e) => handleInputChange('Value', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body" sx={{ color: 'var(--text-primary)' }}>Add to:</Typography>
        </Grid>
        <Grid item xs={9}>
          <Select
            size="small"
            variant="outlined"
            value={authType}
            onChange={(e) => handleInputChange('authType', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          >
            <MenuItem value={"headers"}>Header</MenuItem>
            <MenuItem value={"query_params"}>Query Params</MenuItem>
          </Select>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApiKeyAuthorization;
